import { h, Host, } from "@stencil/core";
import { PageChangeEventType } from "./types";
import { ICON_NAMESPACE } from "../../icons/namespace";
/**
 * Page navigation with ability to jump to first and last pages with `pageCount` is provided.
 */
export class Pagination {
    constructor() {
        this.triggerPageChange = (e) => {
            this.update.emit(e);
        };
        this.first = () => {
            this.triggerPageChange(PageChangeEventType.First);
        };
        this.previous = () => {
            this.triggerPageChange(PageChangeEventType.Previous);
        };
        this.next = () => {
            this.triggerPageChange(PageChangeEventType.Next);
        };
        this.last = () => {
            this.triggerPageChange(PageChangeEventType.Last);
        };
        this.pageCount = undefined;
        this.current = undefined;
    }
    render() {
        const finite = this.pageCount != null;
        return (h(Host, { key: '98e4afd245113e629e1eac199f1e8bcb46bc1979', role: 'navigation', "aria-label": 'pagination' }, finite && (h("es-button", { key: '4e996faf4606013c925befd63fe98b4c5f34f555', role: 'button', "aria-label": 'First page', variant: 'minimal', disabled: this.current === 1, onClick: this.first }, h("es-icon", { key: '52d17f44aa2a11341a4f7d48962f5960d4ff425c', icon: [ICON_NAMESPACE, 'chevron-double'], angle: 90, size: 12 }))), h("es-button", { key: 'b2f837959141be4cd5cfe3f8d47db18148775bae', role: 'button', "aria-label": 'Previous page', variant: 'minimal', disabled: this.current === 1, onClick: this.previous }, h("es-icon", { key: 'd4aa5d7f848ebae6f07afc4330491621d11c9b6a', icon: [ICON_NAMESPACE, 'chevron'], angle: 90, size: 12 })), h("div", { key: '147b7da638c2b4536a61ebdae07a54893a871dbd' }, h("span", { key: '0b50a7c355b1dc95ce4c1246a255e189a6543e5d' }, this.current), finite && (h("span", { key: '94cb9f897f377247842ef9612e128df15a0f6823', class: 'page-count' }, " / ", this.pageCount))), h("es-button", { key: 'c048f3dfa3bb43e4bef10aad4f8b3d10a7ad9d9c', role: 'button', "aria-label": 'Next page', variant: 'minimal', disabled: this.current === this.pageCount && finite, onClick: this.next }, h("es-icon", { key: '7b9d83fcd03caa2303eb92fe467c22fd37353ea3', icon: [ICON_NAMESPACE, 'chevron'], angle: -90, size: 12 })), finite && (h("es-button", { key: 'c0226087afce54350dad57ae08735f50faafd121', role: 'button', "aria-label": 'Last page', variant: 'minimal', disabled: this.current === this.pageCount && finite, onClick: this.last }, h("es-icon", { key: 'd816936363038b71f42a56ae9ded06bc12643570', icon: [ICON_NAMESPACE, 'chevron-double'], angle: -90, size: 12 })))));
    }
    static get is() { return "es-pagination"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-pagination.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-pagination.css"]
        };
    }
    static get properties() {
        return {
            "pageCount": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Number of pages."
                },
                "attribute": "page-count",
                "reflect": false
            },
            "current": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Current Page."
                },
                "attribute": "current",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "update",
                "name": "update",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Triggered when a pagination button is clicked"
                },
                "complexType": {
                    "original": "PageChangeEventType",
                    "resolved": "PageChangeEventType.First | PageChangeEventType.Last | PageChangeEventType.Next | PageChangeEventType.Previous",
                    "references": {
                        "PageChangeEventType": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/es-pagination/types.ts::PageChangeEventType"
                        }
                    }
                }
            }];
    }
}
//# sourceMappingURL=es-pagination.js.map
